//#region src/price-plans/enum/price-plan-type-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.one_shot = "one_shot", e.subscription = "subscription", e.limited_subscription = "limited_subscription", e;
}({});
//#endregion
export { e as PricePlanTypeEnum };
